'use strict';

exports.__esModule = true;
exports.default = escape;
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/escape.js
// module id = 988
// module chunks = 0